export class PatientInsuranceModel {
patientcode = '' ;
medcompany = 0 ;
patientid = '' ;
contcompany = '' ;
expdate = '2024-01-01' ;
medperc = 0 ;
outpatper = 0 ;
labperc = 0 ;
notes = '' ;
userid = '' ;
modifaieddate = '2024-01-01' ;
compcode = '' ;

}
